import { useTranslations } from 'next-intl';
import { Callout } from '../../../../Callout/Callout';
import { getLineInfo } from '../../../extras';
import type { LotteryName, Participation } from '../../../types';

type LineExtraInfoProps = {
  lotteryName: LotteryName;
  participation: Participation;
  lineNumber: number;
  className?: string;
};

function LineExtraInfo({ lotteryName, participation, lineNumber, className }: LineExtraInfoProps) {
  const t = useTranslations('lotteries.ticket_details.your_numbers_section.extras');
  const info = getLineInfo(lotteryName, participation, lineNumber);

  if (!info) return null;

  return (
    <Callout variant="secondary" className={className}>
      {t(info.translationKey, info.translationParams)}
    </Callout>
  );
}

export { LineExtraInfo };
